import SEGMENT_LOGO from 'images/segment-logo.svg'
import JS_LOGO from 'images/javascript-logo.png'
import WORDPRESS_LOGO from 'images/wordpress-logo.svg'

export const INSTALL_OPTIONS = Object.freeze([
  {
    title: "Javascript",
    path: "/js",
    logoSrc: JS_LOGO
  },
  {
    title: "Segment",
    path: "/segment",
    logoSrc: SEGMENT_LOGO
  },
  {
    title: "Wordpress",
    path: "/wordpress",
    logoSrc: WORDPRESS_LOGO
  }
])

export const SNIPPET_TYPES = Object.freeze({
  "JAVASCRIPT": "JavaScript",
  "WORDPRESS": "WordPress"
})


// WEBPACK FOOTER //
// ./src/layouts/OnboardingInstallStep/constants.js